import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import {
  Card,
  CardMedia,
  CardContent,
  CardActions,
  CardActionArea,
  Collapse,
  IconButton,
  Typography,
} from "@material-ui/core";

import { Favorite, Share, ExpandMore } from "@material-ui/icons";

import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 200,
  },
  title: {
    height: 70,
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
}));

const CourseCard = ({ course }) => {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card className={classes.root}>
      <CardActionArea component={Link} to={`/courses/${course.id}`}>
        <CardMedia
          className={classes.media}
          image={course.image}
          // title={course.tenKhoaHoc}
          title={course.title}
        />
        <CardContent>
          <Typography
            className={classes.title}
            gutterBottom
            variant="subtitle2"
            component="h5"
          >
            {/* {course.tenKhoaHoc} */}
            {course.title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {/* {course.luotXem} views */}
            {course.books.length} Smart Books
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {course.videos.length} Interactive Videos
          </Typography>
        </CardContent>
      </CardActionArea>

      <CardActions disableSpacing>
        <IconButton aria-label="share">
          <Share />
        </IconButton>
        <IconButton aria-label="add to favorites">
          <Favorite />
        </IconButton>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMore />
        </IconButton>
      </CardActions>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography paragraph variant="body2">
            {/* {course.moTa} */}
            {course.desc}
          </Typography>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default CourseCard;
